import { sendMediaToVerisk } from '@app/actions/media';
import {
  NEW_MESSAGE,
  SET_ACTIVE_CHAT_MEDIA,
  UPDATE_MEDIA,
  REDACT_IMAGE,
  UPDATE_VIRUS_SCAN_STATUS,
} from '../constants/actions';

const initialState = {};

const reducer = (state = initialState, action) => {
  const { payload = {} } = action;
  switch (action.type) {
    case SET_ACTIVE_CHAT_MEDIA: {
      const { media = [] } = payload?.chat || {};
      const updatedState = { };
      media.forEach((mediaItem) => {
        const {
          mediaInfo,
          providerId,
          fileUrl,
          _id: messageId,
          isImageRedacted,
          redactionData,
          body = '',
          veriskUploadStatus,
        } = mediaItem;
        const hasImageRedactionData = redactionData?.find((r) => r.Type === REDACT_IMAGE);
        updatedState[fileUrl] = {
          mediaInfo,
          fileUrl,
          messageId,
          providerId,
          rotation: 0,
          body,
          isImageRedacted: isImageRedacted || hasImageRedactionData,
          virusScanStatus: mediaItem?.virusScanStatus,
          veriskUploadStatus,
        };
      });
      return updatedState;
    }
    case NEW_MESSAGE: {
      const {
        message = {},
      } = payload;
      const {
        fileUrl,
        mediaInfo,
        providerId,
        id: messageId,
        // new message event uses the model, which translates
        // body -> messagebody
        messageBody = '',
      } = message;
      if (!fileUrl) {
        return state;
      }
      return ({
        ...state,
        [fileUrl]: {
          mediaInfo,
          fileUrl,
          providerId,
          messageId,
          body: messageBody,
          rotation: 0,
        },
      });
    }
    case UPDATE_MEDIA: {
      const { fileUrl } = payload;
      return ({
        ...state,
        [fileUrl]: payload,
      });
    }
    case REDACT_IMAGE: {
      const { fileUrl } = action.payload;

      const updatedState = { ...state };
      const theMediaItem = updatedState[fileUrl] || {};

      updatedState[fileUrl] = {
        ...theMediaItem,
        isImageRedacted: true,
      };

      return updatedState;
    }
    case UPDATE_VIRUS_SCAN_STATUS: {
      const { fileUrl, virusScanStatus } = action.payload;

      const updatedState = { ...state };
      const theMediaItem = updatedState[fileUrl] || {};

      updatedState[fileUrl] = {
        ...theMediaItem,
        virusScanStatus,
      };

      return updatedState;
    }
    case sendMediaToVerisk?.fulfilled?.type: { // updates status of one or many media messages
      const { success, failed } = action.payload;
      const updatedState = { ...state };
      success.forEach((fileName) => {
        const theMediaItem = updatedState[`/api/newmedia/${fileName}`] || {};
        updatedState[`/api/newmedia/${fileName}`] = {
          ...theMediaItem,
          veriskUploadStatus: 'success',
        };
      });
      failed.forEach((fileName) => {
        const theMediaItem = updatedState[`/api/newmedia/${fileName}`] || {};
        updatedState[`/api/newmedia/${fileName}`] = {
          ...theMediaItem,
          veriskUploadStatus: 'failed',
        };
      });
      return updatedState;
    }
    case sendMediaToVerisk?.pending?.type: {
      const updatedState = { ...state };
      const [mediaMessageItem] = action.meta.arg.mediaMessageData;
      const theMediaItem = updatedState[`/api/newmedia/${mediaMessageItem.fileName}`] || {};
      updatedState[`/api/newmedia/${mediaMessageItem.fileName}`] = {
        ...theMediaItem,
        veriskUploadStatus: 'pending',
      };
      return updatedState;
    }
    default:
      return state;
  }
};

export default reducer;
